/*
https://github.com/kazupon/vue-i18n/issues/184
Cannot read property '_t' of null

Cuando un componente se destruye, la variable $i18n se asigna a null. Esto es un
problema porque en ocasiones hacemos redirección de una pantalla a otra y las
promesas pendientes dan un error cuando acaban e intentan mostrar un mensaje.

En vue-i18n no lo ven como un bug y lo ven como un uso inadecuado del método $t().
*/

const VueI18nFailSafe = {
  install(Vue) {
    const _$t = Vue.prototype.$t;
    Vue.prototype._$t = _$t;

    Vue.prototype.$t = function () {
      if (this.$i18n) {
        // Todo va bien, el componente no ha sido destruido
        return _$t.apply(this, arguments);
      } else {
        // Usamos el componente raíz
        return _$t.apply(this.$root, arguments);
      }
    };
  },
};

export default VueI18nFailSafe;
